import * as cart from "@shopify/theme-cart";
import { ApplicationController, useDebounce } from "stimulus-use";

export default class extends ApplicationController {
  static debounces = ["add", "subtract"];
  static targets = ["quantity"];
  static values = { key: String, line: Number };

  connect() {
    useDebounce(this, { wait: 350 });
  }

  async add() {
    const data = {
      line: this.lineValue,
      quantity: Number(this.quantityTarget.value),
    };
    const response = await fetch(window.routes.cart_change_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify(data),
    }).then((res) => res.json());

    this.dispatch("added", response);
  }

  async subtract() {
    const data = {
      line: this.lineValue,
      quantity: Number(this.quantityTarget.value),
    };
    const response = await fetch(window.routes.cart_change_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify(data),
    }).then((res) => res.json());

    this.dispatch("subtracted", response);
  }

  async remove(ev) {
    ev.preventDefault();

    await cart.removeItem(this.keyValue);

    this.dispatch("removed", {});
  }
}
